export default __webpack_public_path__ + "static/headshot-stacey-1bd2c173cf33c0a344979d7a6f8de871.jpg";